import React from 'react';

// https://formik.org/docs/api/field
// https://formik.org/docs/api/fastfield

export const getMUIFormikFieldProps = (meta) => {
  return {
    fullWidth: true,
    error: Boolean(meta.touched && meta.error),
    helperText: meta.touched && meta.error,
  };
};

export const renderField =
  (Field, props) =>
  ({ field, meta }) => {
    return <Field {...getMUIFormikFieldProps(meta)} {...field} {...props} />;
  };
